import { type ReactElement } from 'react';
import { s } from '@/theme/tokens';
import { TableCell } from '@/ui/primitives';
import { TableV2MetricChip } from './TableV2MetricChip';
import { TableV2SortableHeader } from './TableV2Primitives';
import type { ApiSort } from '@/ui/composites/grid/gridUtils';
import type { MetricThresholdGroup } from '@flowqa/shared';

export type TableV2MetricSortField =
  | 'executionAverageDurationMs'
  | 'executionFlakeScore'
  | 'executionFrequencyPerDay'
  | 'executionPassRate';

type TableV2MetricValues = {
  averageDurationMs?: number | null;
  flakeScore?: number | null;
  frequencyPerDay?: number | null;
  passRate?: number | null;
};

export const TableV2MetricHeaders = ({
  sort,
  sortingDisabled = false,
  onSortChange,
}: {
  sort: ApiSort;
  sortingDisabled?: boolean;
  onSortChange: (field: TableV2MetricSortField) => void;
}): ReactElement => (
  <>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2SortableHeader
        activeSort={sort}
        disabled={sortingDisabled}
        field="executionPassRate"
        label="Success Rate"
        onSortChange={onSortChange}
      />
    </TableCell>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2SortableHeader
        activeSort={sort}
        disabled={sortingDisabled}
        field="executionFrequencyPerDay"
        label="Frequency"
        onSortChange={onSortChange}
      />
    </TableCell>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2SortableHeader
        activeSort={sort}
        disabled={sortingDisabled}
        field="executionAverageDurationMs"
        label="Avg. Duration"
        onSortChange={onSortChange}
      />
    </TableCell>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2SortableHeader
        activeSort={sort}
        disabled={sortingDisabled}
        field="executionFlakeScore"
        label="Flake Score"
        onSortChange={onSortChange}
      />
    </TableCell>
  </>
);

export const TableV2MetricCells = ({
  metrics,
  thresholds,
}: {
  metrics: TableV2MetricValues | null;
  thresholds: MetricThresholdGroup;
}): ReactElement => (
  <>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2MetricChip
        kind="passRate"
        threshold={thresholds.passRate}
        value={metrics?.passRate ?? null}
      />
    </TableCell>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2MetricChip
        kind="frequency"
        threshold={thresholds.frequency}
        value={metrics?.frequencyPerDay ?? null}
      />
    </TableCell>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2MetricChip
        kind="avgDuration"
        threshold={thresholds.avgDuration}
        value={metrics?.averageDurationMs ?? null}
      />
    </TableCell>
    <TableCell sx={{ pl: s('none'), textAlign: 'left' }}>
      <TableV2MetricChip
        kind="flakeScore"
        threshold={thresholds.flakeScore}
        value={metrics?.flakeScore ?? null}
      />
    </TableCell>
  </>
);
